<template>
  <app-collapse
    ref="collapseRef"
    variant="muted"
    hide-toggle
    :disabled="disabled"
    inner-class="pt-4 flex flex-col gap-2"
  >
    <template #heading>
      <span class="font-normal">{{ label }}</span>
      <div class="ml-auto text-right">
        <div>{{ amount }}</div>
        <div
          v-if="!disabled && !collapseRef?.isOpen"
          class="text-xs text-gray-600 font-normal"
        >
          View breakdown
        </div>
      </div>
    </template>
    <slot />
    <div
      v-show="collapseRef?.isOpen"
      class="text-xs text-gray-600 text-right cursor-pointer"
      @click.stop="collapseRef.isOpen = false"
    >
      See less
    </div>
  </app-collapse>
</template>

<script setup>
import { ref } from 'vue';

defineOptions({
  name: 'ReservationDetailsPricingBreakdown',
});

defineProps({
  label: {
    type: String,
    required: true,
  },
  amount: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const collapseRef = ref(null);
</script>
